import { createContext, useContext } from 'react'

/**
 * WHAT A POOLED FIGURE ON THE CALENDAR COVERS, IN THE SERVER'S WORDS.
 *
 * At a combined inventory of two or more listings the pooled occupancy, the room pace table's pooled
 * row and ADR are the building's (docs/plans/2026-10-16-combined-inventory.md §3.17: every number says
 * what it covers). The calendar pages send `pooledOccupancyLabel: "Building"` and
 * `adrLabel: "Building ADR"`; everywhere else both are null and each surface keeps the word it has
 * always used. Provided once by each calendar page and read by the hover card, the day details and
 * the month strip, so none of the grids between them threads it.
 */
export interface FigureScope {
  /** "Building", or null: the pace table's pooled row keeps "Property". */
  pooledLabel: string | null
  /** "Building ADR", or null: ADR keeps "ADR". */
  adrLabel: string | null
}

export const UNSCOPED: FigureScope = { pooledLabel: null, adrLabel: null }

export const FigureScopeContext = createContext<FigureScope>(UNSCOPED)

export function useFigureScope(): FigureScope {
  return useContext(FigureScopeContext)
}
